module.exports = __webpack_public_path__ + "img/shuffle.4f772cb0.svg";